import type {
    AmenitiesPagePropertyOnboardingContextFieldsV2,
    AmenitiesPagePropertyOnboardingContextIdsV2,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    AmenitiesPagePropertyOnboardingContextManifestV2,
    WebListYourPropertyAmenitiesVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/amenities-page";
import {
    AmenitiesElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
    ShowAllAmenitiesElementPropertyOnboardingManifestV1,
    ShowLessAmenitiesElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const amenitiesBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<
        AmenitiesPagePropertyOnboardingContextIdsV2,
        AmenitiesPagePropertyOnboardingContextFieldsV2
    >(AmenitiesPagePropertyOnboardingContextManifestV2.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        onboarding_id: BaseContextFieldsMapping.onboarding_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebListYourPropertyAmenitiesVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click, reveal], AmenitiesElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "amenity-id"),
    });
    webAnalytics.observeElement([click], ShowAllAmenitiesElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ShowLessAmenitiesElementPropertyOnboardingManifestV1.ids, {});
});
